Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = areMomentRangesEqual;

function areMomentRangesEqual(r1, r2) {
  return r1.start.isSame(r2.start, 'day') && r1.end.isSame(r2.end, 'day');
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-daterange-picker/dist/utils/areMomentRangesEqual.js
// module id = 1175
// module chunks = 0